import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import styles from './ResultsFor.module.scss';

const ResultsFor = ({ children }) => (
  <h1 className={styles.ResutlsFor}>
    Results for: "<span>{children}</span>"
    <Link to="/blog/1" className="btn btn-lg mx-2 my-0 p-0">
      <i className="fa fa-times-circle fa-inverse" />
    </Link>
  </h1>
);

ResultsFor.propTypes = {
  children: PropTypes.node,
};

ResultsFor.defaultProps = {
  children: '',
};

export default ResultsFor;
